import ApiBaseService from './ApiBaseService';

class MasterService {

    //SPORT TYPE
    static getSpotsTypeList([data]) {
        return ApiBaseService.request('/api/web/master/sports_type/list', 'POST', data);
    }
    static getDropdownSportsType([data = {}]) {
        return ApiBaseService.request('/api/web/sports_type/dropdown', 'POST', data);
    }
    static createSpotsType([data]) {
        return ApiBaseService.request('/api/web/master/sports_type/create', 'POST', data);
    }
    static updateSportsTypeByUuid([data, stUuid]) {
        return ApiBaseService.request(`/api/web/master/sports_type/update/${stUuid}`, 'PUT', data);
    }
    static getSportsTypeByUuid([stUuid]) {
        return ApiBaseService.request(`/api/web/master/sports_type/details/${stUuid}`, 'GET');
    }
    static removeSportsTypeByUuid([stUuid]) {
        return ApiBaseService.request(`/api/web/master/sports_type/remove/${stUuid}`, 'PUT', {});
    }

    // CANCELLATION RULE
    static getCancellationRuleList([data]) {
        return ApiBaseService.request('/api/web/master/cancellation_rule/list', 'POST', data);
    }
    static createCancellationRule([data]) {
        return ApiBaseService.request('/api/web/master/cancellation_rule/create', 'POST', data);
    }
    static updateCancelationRuleByUuid([data, ruleUuid]) {
        return ApiBaseService.request(`/api/web/master/cancellation_rule/update/${ruleUuid}`, 'PUT', data);
    }
    static getCancelationRuleByUuid([ruleUuid]) {
        return ApiBaseService.request(`/api/web/master/cancellation_rule/details/${ruleUuid}`, 'GET');
    }
    static removeCancelationRuleByUuid([ruleUuid]) {
        return ApiBaseService.request(`/api/web/master/cancellation_rule/remove/${ruleUuid}`, 'PUT', {});
    }

    // CONVENIENCE FEE
    static getConvenienceList([data = {}]) {
        return ApiBaseService.request('/api/web/master/convenience_fee/list', 'POST', data);
    }
    static createConvenience([data]) {
        return ApiBaseService.request('/api/web/master/convenience_fee/create', 'POST', data);
    }

}

export default MasterService;